import { ENV } from "@/configs/env"

export type SiteId = "tamdamedia.eu" | "tamdagroup.eu"

// Bảng host tuyệt đối → site. Staging và production dùng chung một build, nên
// đổi nginx qua lại giữa 2 cụm KHÔNG cần build lại.
//
//   production   tamdagroup.eu       tamdamedia.eu
//   staging      dev.tamdagroup.eu   media.tamdagroup.eu
//
// Bảng này phải khớp SITE_HOSTS trong next.config.mjs — rewrite (chọn route
// /sites/<site>/…) và getSiteIdFromHost (chọn siteId trong client component)
// phải ra cùng một site, nếu lệch thì layout server và header client đá nhau.
export const HOST_TO_SITE_ID: Record<string, SiteId> = {
  "tamdamedia.eu": "tamdamedia.eu",
  "media.tamdagroup.eu": "tamdamedia.eu",
  "tamdagroup.eu": "tamdagroup.eu",
  "dev.tamdagroup.eu": "tamdagroup.eu",
}

export function getSiteIdFromHost(host?: string | null): SiteId {
  const hostname = (host || "").split(":")[0].toLowerCase()

  if (ENV.isDev && (!hostname || hostname === "localhost" || hostname === "127.0.0.1")) {
    return (process.env.NEXT_PUBLIC_DEV_SITE as SiteId) || "tamdamedia.eu"
  }

  const bare = hostname.startsWith("www.") ? hostname.slice(4) : hostname

  return HOST_TO_SITE_ID[bare] ?? "tamdamedia.eu"
}
